import React from 'react';
import { ChevronRightIcon as HeroChevronRightIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ChevronRightIconProps = Omit<IconProps, 'children'>;

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroChevronRightIcon />
        </Icon>
    );
};
